module.exports = __webpack_public_path__ + "static/m-600-sitting-on-pool-edge-806a65bed03ead2069ac07e8f6baad4d.jpg";